export default "__VITE_ASSET__uCvLigGx__"